import { render, staticRenderFns } from "./advZiZhi.vue?vue&type=template&id=358cefb7"
import script from "./advZiZhi.vue?vue&type=script&lang=js"
export * from "./advZiZhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports